function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Col, Form, Table as BtTable, Row } from 'react-bootstrap';
import { Button, DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { t } from 'i18next';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import FinancialYear from './FinancialYear';
import UploadDocumentsModal from './UploadDocumentsModal';
import './tableScroll.css';
import { useTranslation } from 'react-i18next';
import InitialAmountTable from './financial_details_tables/InitialAmountTable';
import FinancialDetailButtons from './financial_details_tables/FinancialDetailButtons';
import ResumeOfCostTable from './financial_details_tables/ResumeOfCostTable';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
const columnWidth = 150;
const buttonStyle = {
  width: '150px'
};
const ContractorFinancialDetailsForm = _ref => {
  let {
    handleDeleteDetail,
    loading,
    contractor,
    handleCreateDetail,
    handleFinancialDetailChange,
    saveFinancialDetailChange,
    saveFinancialYearChange,
    addFile,
    removeAttachment,
    setSelectedContractor,
    applicationSubmitted,
    handleChange,
    handleSubmit,
    setSelectedYear,
    selectedYear,
    closeForm,
    setHasUnsavedChanges: setParentHasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const wrappedHandleFinancialDetailChange = (e, id) => {
    setHasUnsavedChanges(true);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
    handleFinancialDetailChange(e, id);
  };
  const wrappedSaveFinancialDetailChange = async detail => {
    const result = await saveFinancialDetailChange(detail);
    setHasUnsavedChanges(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
    return result;
  };
  const wrappedSaveFinancialYearChange = async function () {
    const result = await saveFinancialYearChange(...arguments);
    setHasUnsavedChanges(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
    return result;
  };
  const wrappedHandleChange = e => {
    setHasUnsavedChanges(true);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
    handleChange(e);
  };
  const wrappedHandleSubmit = async () => {
    await handleSubmit();
    setHasUnsavedChanges(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const handleCloseForm = () => {
    if (hasUnsavedChanges) {
      var _window$MARKET_CONSTA;
      const message = t((_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.UNSAVED_CHANGES_MESSAGE);
      if (window.confirm(message)) {
        setHasUnsavedChanges(false);
        if (closeForm) {
          closeForm();
        }
      }
    } else {
      if (closeForm) {
        closeForm();
      }
    }
  };
  const sortFinancialDetails = financialDetails => {
    return financialDetails.sort(a => {
      if (a.cost_type === 'estimate') {
        return 1;
      } else {
        return -1;
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(UploadDocumentsModal, {
    showModal: showModal,
    setShowModal: setShowModal,
    handleSubmit: addFile,
    financialDetails: sortFinancialDetails(contractor.financial_details)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'scroll'
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    style: {
      maxWidth: columnWidth + 20 + 'px'
    }
  }), /*#__PURE__*/React.createElement(Col, {
    md: {
      offset: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 3 * columnWidth + 'px'
    }
  }, /*#__PURE__*/React.createElement(InitialAmountTable, {
    handleChange: wrappedHandleChange,
    handleSubmit: wrappedHandleSubmit,
    contractor: contractor
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex flex-column justify-content-end",
    style: {
      maxWidth: columnWidth + 20 + 'px'
    }
  }, /*#__PURE__*/React.createElement(FinancialDetailButtons, {
    applicationSubmitted: applicationSubmitted,
    handleCreateDetail: handleCreateDetail,
    buttonStyle: buttonStyle,
    setShowModal: setShowModal,
    contractor: contractor,
    loading: loading
  })), /*#__PURE__*/React.createElement(Col, {
    md: {
      offset: 1
    }
  }, /*#__PURE__*/React.createElement(ResumeOfCostTable, {
    contractor: contractor,
    columnWidth: columnWidth
  }))), /*#__PURE__*/React.createElement(Row, {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '1rem',
      maxWidth: '470px',
      margin: '0 auto'
    }
  }, contractor.cost_calculations.total_per_year.map(entity => {
    const year = String(entity.year);
    return /*#__PURE__*/React.createElement(Col, {
      key: entity.year + 'yearbtn',
      style: {
        width: columnWidth
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: selectedYear === year,
      onClick: () => setSelectedYear(year),
      variant: 'primary',
      className: 'mt-2 mr-2',
      style: buttonStyle
    }, entity.year));
  })), /*#__PURE__*/React.createElement(BtTable, {
    size: "md"
  }, /*#__PURE__*/React.createElement("tbody", null, sortFinancialDetails(contractor.financial_details).map((detail, index) => /*#__PURE__*/React.createElement("tr", {
    key: "tr".concat(index)
  }, /*#__PURE__*/React.createElement("td", {
    key: "tr".concat(index, "td1")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex ml-3"
  }, /*#__PURE__*/React.createElement(Col, {
    style: {
      width: '100px'
    }
  }, t(detail.cost_type)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => wrappedHandleFinancialDetailChange(e, detail.id),
    onBlur: async () => {
      const newFinancialDetail = await wrappedSaveFinancialDetailChange(detail);
      if (newFinancialDetail !== null && newFinancialDetail !== void 0 && newFinancialDetail.cost_calculations) {
        setSelectedContractor(prevContractor => {
          return _objectSpread(_objectSpread({}, prevContractor), {}, {
            cost_calculations: newFinancialDetail.cost_calculations
          });
        });
      }
    },
    object: detail,
    name: "name",
    type: "text",
    disabled: applicationSubmitted,
    style: {
      minWidth: '150px'
    }
  })), /*#__PURE__*/React.createElement(Col, {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    variant: "danger",
    size: "sm",
    className: "text-white mx-2",
    disabled: applicationSubmitted,
    onClick: () => handleDeleteDetail(detail.id)
  })))), /*#__PURE__*/React.createElement("td", {
    key: "tr".concat(index, "td2")
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => wrappedHandleFinancialDetailChange(e, detail.id),
    onBlur: () => wrappedSaveFinancialDetailChange(detail),
    object: detail,
    name: "comments",
    controlAs: "textarea",
    rows: "3",
    disabled: applicationSubmitted,
    style: {
      width: '280px',
      height: '100px'
    }
  })), detail.filtered_financial_years.filter(fy => String(fy.year) === String(selectedYear)).map(financialYear => {
    return /*#__PURE__*/React.createElement("td", {
      key: "tr".concat(index, "td").concat(financialYear.year),
      className: detail.cost_type === 'offer' ? 'contractor-years' : '',
      style: {
        paddingLeft: '40px'
      }
    }, /*#__PURE__*/React.createElement(FinancialYear, {
      applicationSubmitted: applicationSubmitted,
      setSelectedContractor: setSelectedContractor,
      contractor: contractor,
      saveFinancialYearChange: wrappedSaveFinancialYearChange,
      financialYear: financialYear,
      detail: detail,
      loading: loading,
      setHasUnsavedChanges: setParentHasUnsavedChanges
    }));
  }), /*#__PURE__*/React.createElement("td", {
    key: "tr".concat(index, "td3")
  }, detail.download_links.map((attachment, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex",
      key: index
    }, /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 2
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "attachment")), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 7
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: attachment.url,
      target: "_blank",
      rel: "noreferrer"
    }, attachment.filename)), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 2
      }
    }, /*#__PURE__*/React.createElement(DeleteButton, {
      variant: "danger",
      size: "sm",
      className: "text-white ms-3",
      onClick: () => removeAttachment(detail, attachment.id, attachment.filename)
    })));
  }))))))));
};
export default ContractorFinancialDetailsForm;